/* Reviewed installation artifact only. NOT installed by deployment or collector.
 * Requires separately authorized theme integration + test-shop acceptance.
 * No fetch, cart mutation, purchase, analytics request, cookie or storage write. */
(() => {
  const match = /^#nm_handoff=([^&]+)$/.exec(location.hash);
  if (!match) return;
  history.replaceState(history.state, '', location.pathname + location.search);
  let token, marker;
  try {
    token = decodeURIComponent(match[1]);
    if (token.length > 600 || !/^[A-Za-z0-9_-]+\.[a-f0-9]{64}$/.test(token)) return;
    // Browser parsing is transport-only. Application verifies signature and the
    // stored permission/search/variant again at the authenticated paid webhook.
    const encoded = token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/');
    marker = JSON.parse(atob(encoded));
    if (marker.v !== 1 || !/^\d+$/.test(marker.variant) || !Number.isSafeInteger(marker.expires) ||
        marker.expires <= Date.now() || marker.expires > Date.now() + 30 * 60 * 1000) return;
  } catch { return; }
  const property = 'properties[_nm_native_handoff]';
  function clear() { document.querySelectorAll(`input[name="${property}"]`).forEach(input => input.remove()); }
  // The theme banner need not load the public API on a returning visit. Load
  // Shopify's supported API explicitly; never set consent or trust a cookie.
  let privacyReady = Boolean(window.Shopify?.customerPrivacy);
  if (!privacyReady) {
    try {
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        privacyReady = !error && Boolean(window.Shopify?.customerPrivacy);
      });
    } catch { /* Optional transport stays unavailable; commerce remains usable. */ }
  }
  const permission = () => {
    if (!privacyReady) return null;
    try {
      const analytics = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
      const marketing = window.Shopify?.customerPrivacy?.marketingAllowed?.();
      return typeof analytics === 'boolean' && typeof marketing === 'boolean' ? analytics && marketing : null;
    } catch { return null; }
  };
  document.addEventListener('visitorConsentCollected', event => {
    clear();
    if (permission() === false || event.detail?.analyticsAllowed === false || event.detail?.marketingAllowed === false) token = null;
  });
  document.addEventListener('submit', event => {
    clear();
    if (!token || permission() !== true || marker.expires <= Date.now()) return;
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname)) return;
    const values = new FormData(form);
    if (values.getAll('id').length !== 1 || String(values.get('id')) !== marker.variant ||
        Number(values.get('quantity') || 1) !== 1) return;
    const input = document.createElement('input'); input.type = 'hidden'; input.name = property; input.value = token;
    form.appendChild(input);
  }, true);
})();
